import { 
  Breadcrumb,
  Button,
  Input,
  message,
  PageHeader,
  Select,
  Form,
  Row,
  Col,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { Auth } from "_helpers";
import {
  workItemService,
  taskService,
} from "_services";
import TabMenu from "./TabMenu";

function Summary({ history, match }) {
  const { id } = match.params;
  const { path } = match;
  const [isLoading, setIsLoading] = useState(false);
  const [item, setItem] = useState({});
  const [jobTasks, setJobTasks] = useState([]); 
  const [form] = Form.useForm();
  const { Option } = Select;

  useEffect(() => {
    getsetJobTasks();
  }, []);

  const getsetJobTasks = () => {
    taskService
      .getSuggestion()
      .then((x) => {
        setJobTasks(x.content); 
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  };

  useEffect(() => {
    setIsLoading(true);
    workItemService
      .getById(id)
      .then((x) => {
        setIsLoading(false);
        setItem(x.content);
        onFill(x.content); 
      })
      .catch((errorInfo) => {
        setIsLoading(false);
        message.error(`${errorInfo}`);
      });
  }, [id]);

  // Fill the form with existing data, including setting jobTasks as array of task IDs
  const onFill = (data) => {
    form.setFieldsValue({
      ...data,
      jobTasks: data.jobTasks?.map((task) => task.id) || [], // Set jobTasks as array of IDs
    });
  };

  const handleFormSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        // Prepare the payload with full job task objects, not just IDs
        const payload = {
          ...values,
          jobTasks: values.jobTasks.map((taskId) => {
            const selectedTask = jobTasks.find((task) => task.id === taskId);
            return {
              id: selectedTask.id,
              code: selectedTask.code,
              name: selectedTask.name,
              jobStatus: selectedTask.selectedTask,
            };
          }),
        };
        setIsLoading(true);
        workItemService
          .update(id, payload)
          .then(() => {
            message.success("Successfully updated!");
            setIsLoading(false);
            history.push(`${path}`);
          })
          .catch((error) => {
            setIsLoading(false);
            message.error(`${error}`);
          });
      })
      .catch((error) => {
        message.error(`${error}`);
      });
  };

  const onCancel = () => {
    history.push("/work-items");
  };

  const getActionButtons = () => {
    let buttons = [];
    if (Auth.hasRole(Auth.getProfile(), ["SAU", "CAU"])) {
      buttons.push(
        <Button
          key="1"
          type="primary"
          htmlType="submit"
          loading={isLoading}
          onClick={handleFormSubmit}
        >
          Save
        </Button>
      );
    }
    buttons.push(
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>
    );
    return buttons;
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/work-items">Work Item Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`${path}`}>Work : {item.code}</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner>
          <TabMenu menu="summary" id={id} />
          <Form
            form={form}
            name="form-create"
            layout="vertical"
            requiredMark={false}
          >
            <Row gutter={24}>
              <Col span={6}>
                <Form.Item
                  name="code"
                  label="Code"
                  rules={[{ required: true, message: "Code is required" }]}
                >
                  <Input placeholder="Code" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[
                    { required: true, message: "Name is required" },
                  ]}
                >
                  <Input placeholder="Name" />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="jobTasks"
                  label="Job Tasks"
                  rules={[{ required: true, message: "At least one Job Task is required" }]}
                >
                  <Select
                    mode="multiple" 
                    placeholder="Please select Job Tasks"
                    allowClear
                  >
                    {jobTasks.map((task) => (
                      <Option value={task.id} key={task.id}>
                        {task.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}></Col>
              <Col span={6}></Col>
            </Row>
          </Form>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Summary;
